import { useEffect } from "react"
import { State } from "../types"

const LOCAL_STORAGE_KEY = "DonationFormState"
const EXPIRATION_TIME = 5 * 60 * 1000 // 5 minutes in milliseconds

export function clearLocalStorage() {
  localStorage.removeItem(LOCAL_STORAGE_KEY)
}

export function tryLoadStateFromLocalStorage(): State | null {
  try {
    const savedData = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (!savedData) return null

    const parsedData = JSON.parse(savedData)
    const now = new Date().getTime()

    if (now - parsedData.timestamp > EXPIRATION_TIME) {
      console.warn("Previous donation form state expired")
      localStorage.removeItem(LOCAL_STORAGE_KEY)
      return null
    }

    if (window.location.search !== parsedData.search) {
      console.warn("Previous donation form state had different search params")
      localStorage.removeItem(LOCAL_STORAGE_KEY)
      return null
    }

    return parsedData.state
  } catch (error) {
    console.error("Error loading state from localStorage:", error)
    return null
  }
}

export function LocalStorageStatePersistence({ state }: { state: State }) {
  useEffect(() => {
    saveToLocalStorage(state)
  }, [state])

  return null
}

function saveToLocalStorage(state: State) {
  try {
    const data = {
      state,
      timestamp: new Date().getTime(),
      search: window.location.search,
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data))
  } catch (error) {
    console.error("Error saving state to localStorage:", error)
  }
}
